import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '../../../../services/api/api.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
 
@Component({
  selector: 'app-email-lookup',
  templateUrl: './email-lookup.component.html',
  styleUrls: ['./email-lookup.component.css']
})
export class EmailLookupComponent implements OnInit {
  public loading: boolean;
  public filteredEmails: any;
  @Output() emailChange = new EventEmitter<any>();
  @Input() public set email(val){ 
    debugger;
    this._email = val;
    if (!val && this.selected != '')
      this.selected = '';
  };
  private _email:any;
  public get selected(){ 
    return this._selected;
  }
  @Input() public set selected(val){ 
    this._selected = val;
    if (val && val.email)
      this.email = val.email;
    else this.email = val;
    if (this.email)
    this.emailChange.emit(this.email)
  };
  private _selected:any;

  public get email(){return this._email;}
  constructor(@Inject(MAT_DIALOG_DATA) public config: any, public ref: MatDialogRef<EmailLookupComponent>,
    private apiService: ApiService,
    private messageService?: ToastrService) {
    
  }

  ngOnInit() {
  }

//   public send() {
//     this.ref.close(this.selected.map(o=>o.email));
//   }

//   public cancel() {
//     this.ref.close();
//   }

//   addToSelected(item){
// if (this.selected.indexOf(item) == -1)
// this.selected.push(item);
//   }

  smartAutoComplete(event, filter?) {
    this.loading = true;
    this.apiService.post(`/api/emailLookups/autocomplete`, {
      query: event.query,
      filter: filter
    })
      .subscribe(filter => {
        this.filteredEmails = filter;
        this.loading = false;
      }, err => {
      });
  }
  

}
